class AAHeadquarters {
  constructor(root) {
    this.root = root;
    this.init();
  }

  init() {
    this.initClients();
    this.initTemplateBuilder();
  }

  initClients() {
    const clientsRoot = this.root.querySelector('[data-aa-clients-list]');
    if (!clientsRoot || !window.AAHeadquartersClients) return;

    new window.AAHeadquartersClients(this.root);
  }

  initTemplateBuilder() {
    const builderRoot = this.root.querySelector('[data-aa-template-builder], [data-aa-playbook-builder]');
    if (!builderRoot || !window.AATemplateBuilder) return;

    new window.AATemplateBuilder(this.root);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-aa-headquarters]').forEach((root) => {
    new AAHeadquarters(root);
  });
});